import React, { useEffect } from "react";
import styled from "styled-components";
import { flexCenterDir, fullPage } from "../styles/theme";
import Table from "./Table";
import { connects } from "../lib/metamask";
import { useSelector } from "react-redux";
import { RootState } from "../store/reducers";

interface IList {
	title: string;
	viewDetailHandler?: any;
	data?: any[];
	getSelector?: any;
}

const List = ({ title, viewDetailHandler, data, getSelector }: IList) => {
	// const projectList = useSelector((state: RootState) => state.projectList);

	// useEffect(() => {
	// }, [])

	return (
		<ListSection>
			<h2>{title}</h2>
			<Table
				title={title}
				viewDetailHandler={viewDetailHandler}
				data={data}
				getSelector={getSelector}
			/>
		</ListSection>
	);
};

const ListSection = styled.section`
	${flexCenterDir}
	${fullPage}

	justify-content: flex-start;

	h2 {
		font-size: 3rem;
		line-height: 2rem;
		width: 70%;
		margin-top: 10rem;
		margin-bottom: 4rem;
	}
`;

export default List;
